import Vue from "vue";
import Router from "vue-router";
import authentication from "../authentication";
import Home from "@/components/Home";
import AdminRoutes from "@/components/admin/routes";
import BillingRoutes from "@/components/billing/routes";
import CalamityRoutes from "@/components/calamities/routes";
import CallsRoutes from "@/components/calls/routes";
import CourierRoutes from "@/components/couriers/routes";
import DeliverabilityRoutes from "@/components/deliverability/routes";
import FlightRoutes from "@/components/flights/routes";
import PackageRoutes from "@/components/packages/routes";
import ParcelShieldUserRoutes from "@/components/parcelshieldusers/routes";
import PhoneRoutes from "@/components/phones/routes";
import QueueRoutes from "@/components/queue/routes";
import TimeTrackingRoutes from "@/components/timetracking/routes";
import UserRoutes from "@/components/users/routes";
import AllianceDemoRoutes from "@/components/allianceDemo/routes";

Vue.use(Router);

const router = new Router({
  mode: "history",
  routes: [
    ...CourierRoutes,
    ...CalamityRoutes,
    ...UserRoutes,
    ...BillingRoutes,
    ...AdminRoutes,
    ...PhoneRoutes,
    ...TimeTrackingRoutes,
    ...ParcelShieldUserRoutes,
    ...FlightRoutes,
    ...CallsRoutes,
    ...PackageRoutes,
    ...AllianceDemoRoutes,
    ...DeliverabilityRoutes,
    ...QueueRoutes,
    {
      path: "/",
      name: "Home",
      component: Home
    },
    {
      path: "*",
      redirect: to => {
        return "/";
      }
    }
  ]
});

router.beforeEach(async (to, from, next) => {
  // Kill Any setIntervals on change route so they don't run on other pages or get recreated
  if (router.app) {
    for (let interval in router.app.$store.intervals) {
      clearInterval(router.app.$store.intervals[interval]);
    }
    router.app.$store.intervals = {};
  }

  if (to.matched.some(record => record.meta.requiresAuthentication)) {
    // this route requires auth, check if logged in
    if (await authentication.isAuthenticated()) {
      // only proceed if authenticated.
      next();
    } else {
      authentication.signIn();
    }
  } else {
    next();
  }
});
export default router;
